import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DownloadOutline from './download-outline-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DownloadOutline {...validProps} />;
}
SvgComponent.iconName = 'downloadOutline';

export const DownloadOutlineIcon = svgIconWrapper(SvgComponent);
